import { render, staticRenderFns } from "./new-billing-rates.vue?vue&type=template&id=7f3ef1df"
import script from "./new-billing-rates.vue?vue&type=script&lang=js"
export * from "./new-billing-rates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports